import { Box, Container, Paper, Typography } from "@mui/material";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "../../../store";
import CompanyLogo from "../../base/CompanyLogo";
import Button from "../../base/Button";
import AddEditUser, { UserFormSubmitHandler } from "../Users/AddEditUser";
import User from "../../../types/user";
import { updateProfile } from "../../../slices/auth";

interface Props {}

const AccountView: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const { status, userCompany } = useSelector((store) => store.auth);
  const { status: userStatus } = useSelector((store) => store.users);

  const formSubmitHandlerRef = useRef<UserFormSubmitHandler | null>(null);

  const handleSave = async (data: User) => {
    await dispatch(updateProfile(data));
  };

  return (
    <Container sx={{ marginBottom: 8 }}>
      <Paper
        sx={{
          paddingY: 3,
          paddingX: { xs: 2, md: 5 },
          marginBottom: 5,
        }}
      >
        <Box
          marginBottom={3}
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="center"
          alignItems="center"
          padding={1}
          gap={3}
        >
          {userCompany?.logo && (
            <CompanyLogo company={userCompany} size="70px" />
          )}
          <Box display="flex" flexDirection="column">
            <Typography variant="h5">
              {`Update profile information for ${userCompany?.companyName}.`}
            </Typography>
          </Box>
        </Box>
        <AddEditUser
          type="profile"
          onSubmit={handleSave}
          ref={formSubmitHandlerRef}
        />
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="flex-end"
          gap={2}
          mt={2}
        >
          <Box display="flex" flexDirection="column" justifyContent="center">
            <Button
              label="Save"
              variant={"contained"}
              color={"primary"}
              onClick={() => formSubmitHandlerRef.current?.()}
              loading={status === "loading" || userStatus === "loading"}
            />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default AccountView;
